import { useRouteMatch } from "react-router-dom";
import urlPaths, { matchPaths } from "src/consts/urlPaths";

export const TAG_ROUTE_PATHS = [urlPaths.TAG_EXPLORE, urlPaths.TAG_DETAILS];

/**
 * Tag or tag-type id from the current tag explore/details route only.
 * Avoids matchPaths() on unrelated routes that also expose an :id param.
 */
const useActiveTagRouteId = () => {
  const tagExploreRouteMatch = useRouteMatch({
    path: urlPaths.TAG_EXPLORE,
    exact: true,
    strict: false,
  });
  const tagDetailsRouteMatch = useRouteMatch({
    path: urlPaths.TAG_DETAILS,
    exact: true,
    strict: false,
  });

  return (
    matchPaths(undefined, TAG_ROUTE_PATHS)?.params?.id ??
    tagExploreRouteMatch?.params?.id ??
    tagDetailsRouteMatch?.params?.id
  );
};

export default useActiveTagRouteId;
